// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Map_Serialized from "../Data.Map.Serialized/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_RouteAsURL from "../Restaumatic.RouteAsURL/index.js";
import * as Unscramble from "../Unscramble/index.js";
var wrap = /* #__PURE__ */ Data_Newtype.wrap();
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var RestaurantId = function (x) {
    return x;
};
var toFillFormTypeRestaurantI = Restaumatic_Form_TestHelpers.toFillFormTypeInt;
var asJSONKeyRestaurantId = Data_Map_Serialized.asJSONKeyInt;
var udecodeRestaurantId = Unscramble.decodeInt1;
var showRestaurantId = Data_Show.showInt;
var ordRestaurantId = Data_Ord.ordInt;
var newtypeRestaurantId = {
    Coercible0: function () {
        return undefined;
    }
};
var fromJSONKeyRestaurantId = /* #__PURE__ */ (function () {
    return {
        fromJSONKey: new Unscramble.FromJSONKeyString(function (x) {
            var v = Data_Int.fromString(x);
            if (v instanceof Data_Maybe.Just) {
                return wrap(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return Unscramble.decodingError("Invalid Int: " + show(x));
            };
            throw new Error("Failed pattern match at Restaumatic.Restaurant.Types.Id (line 30, column 5 - line 32, column 61): " + [ v.constructor.name ]);
        })
    };
})();
var eqRestaurantId = Data_Eq.eqInt;
var encodeRestaurantId = Foreign_Generic_Class.intEncode;
var decodeRestaurantId = Foreign_Generic_Class.intDecode;
var asParamRestaurantId = Restaumatic_RouteAsURL.asParamInt;
export {
    RestaurantId,
    newtypeRestaurantId,
    showRestaurantId,
    eqRestaurantId,
    ordRestaurantId,
    encodeRestaurantId,
    decodeRestaurantId,
    udecodeRestaurantId,
    asParamRestaurantId,
    asJSONKeyRestaurantId,
    toFillFormTypeRestaurantI,
    fromJSONKeyRestaurantId
};
